import { EntityApiService, ApiClientService } from "@dfl/react-security";
import { IGeneralSettings } from "modules/settings/interfaces";

class GeneralSettingsService extends EntityApiService<IGeneralSettings> {
	getSettings = (): Promise<IGeneralSettings> => {
		return this.handleResponse(
			ApiClientService.get(this.getPath("/current"))
		) as Promise<IGeneralSettings>;
	};
	getPublicSettings = (): Promise<IGeneralSettings> => {
		return this.handleResponse(
			ApiClientService.get(this.getPath("/current-to-public"))
		) as Promise<IGeneralSettings>;
	};

	saveSettings = (payload: any) => {
		return this.handleResponse(
			ApiClientService.patch(
				this.getPath(`/${payload._id}/configuration`),
				payload
			)
		);
	};
	
	patchSettings = (payload: any) => {
		return this.handleResponse(
			ApiClientService.patch(this.getPath(`/${payload._id}`), payload)
		);
	};
}

export default new GeneralSettingsService("/ms-auth/api/spaces");
